import { gobernanzaData } from '@/mocks/nosotros-data';

const organigramNodes = [
  {
    id: 'asamblea',
    label: 'Asamblea General',
    type: 'primary',
    isTop: true,
  },
  {
    id: 'consejo',
    label: 'Consejo Directivo',
    type: 'primary',
    isTop: false,
  },
  {
    id: 'direccion',
    label: 'Dirección General',
    type: 'primary',
    isTop: false,
  },
];

const sideNodes = [
  {
    id: 'vigilancia',
    label: 'Comité de Vigilancia',
    description: 'Órgano de supervisión y fiscalización',
    side: 'left',
  },
  {
    id: 'electoral',
    label: 'Comité Electoral',
    description: 'Órgano autónomo electoral',
    side: 'right',
  },
];

export default function GobernanzaSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
              Estructura orgánica
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-5">
              {gobernanzaData.title}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              {gobernanzaData.description}
            </p>
          </div>

          {/* Organigram */}
          <div className="relative pt-4">
            {/* Main vertical chain */}
            <div className="flex flex-col items-center gap-0 relative">
              {organigramNodes.map((node, idx) => (
                <div key={node.id} className="relative flex flex-col items-center">
                  {/* Connector line above */}
                  {!node.isTop && (
                    <div className="w-px h-8 bg-secondary-300" />
                  )}

                  {/* Node */}
                  <div className={`relative z-10 px-6 py-4 rounded-2xl border text-center transition-all duration-300 ${
                    node.type === 'primary'
                      ? 'bg-primary-500 border-primary-500 text-white'
                      : 'bg-background-50 border-secondary-200/60 text-foreground-900'
                  }`}>
                    <span className="font-heading text-sm md:text-base font-bold whitespace-nowrap">
                      {node.label}
                    </span>
                  </div>

                  {/* Connector line below */}
                  {idx < organigramNodes.length - 1 && (
                    <div className="w-px h-8 bg-secondary-300" />
                  )}
                </div>
              ))}
            </div>

            {/* Side nodes */}
            {sideNodes.map((node) => (
              <div
                key={node.id}
                className={`absolute top-[calc(100%-2rem)] md:top-[calc(100%-2.5rem)] ${
                  node.side === 'left'
                    ? 'left-0 md:left-4'
                    : 'right-0 md:right-4'
                }`}
              >
                <div className="flex flex-col items-center">
                  {/* Horizontal connector */}
                  <div className="flex items-center">
                    {node.side === 'right' ? (
                      <>
                        <div className="w-8 md:w-12 h-px bg-secondary-300" />
                        <div className="w-px h-8 bg-secondary-300" />
                        <div className="w-8 md:w-12 h-px bg-secondary-300" />
                      </>
                    ) : (
                      <>
                        <div className="w-8 md:w-12 h-px bg-secondary-300" />
                        <div className="w-px h-8 bg-secondary-300" />
                        <div className="w-8 md:w-12 h-px bg-secondary-300" />
                      </>
                    )}
                  </div>
                  {/* Node */}
                  <div className="px-4 py-3 rounded-xl bg-background-50 border border-secondary-200/60 text-center">
                    <span className="block font-heading text-sm font-bold text-foreground-900 whitespace-nowrap mb-1">
                      {node.label}
                    </span>
                    <span className="block text-foreground-500 text-xs whitespace-nowrap">
                      {node.description}
                    </span>
                  </div>
                </div>
              </div>
            ))}

            {/* Bottom spacer for side nodes */}
            <div className="h-24 md:h-28" />
          </div>
        </div>
      </div>
    </section>
  );
}